module.exports = __webpack_public_path__ + "img/欧瑞斯LOGO-白.7187afa0.png";